export default __webpack_public_path__ + "static/media/menu-gupshup-logo.66ae49a1.png";